// extracted by mini-css-extract-plugin
export default {"QuestionsList":"QuestionsList_QuestionsList__x5rFm","title":"QuestionsList_title__MKLEn","questionsWrapper":"QuestionsList_questionsWrapper__-+xIM"};